import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

interface LogCounts {
  unresolved: number;
  needsAttention: number;
}

export const useLogCounts = (): LogCounts => {
  const [counts, setCounts] = useState<LogCounts>({ unresolved: 0, needsAttention: 0 });

  useEffect(() => {
    // Query for unresolved logs (resolved == false)
    const unresolvedQuery = query(
      collection(db, 'logs'),
      where('resolved', '==', false)
    );

    // Query for needs attention logs (attentionRequired == true && acknowledged == false)
    const needsAttentionQuery = query(
      collection(db, 'logs'),
      where('attentionRequired', '==', true),
      where('acknowledged', '==', false)
    );

    const unsubscribeUnresolved = onSnapshot(
      unresolvedQuery,
      (snapshot) => {
        setCounts((prev) => ({ ...prev, unresolved: snapshot.size }));
      },
      (err) => {
        console.warn('[useLogCounts] Failed to fetch unresolved count', err);
      }
    );

    const unsubscribeNeedsAttention = onSnapshot(
      needsAttentionQuery,
      (snapshot) => {
        setCounts((prev) => ({ ...prev, needsAttention: snapshot.size }));
      },
      (err) => {
        console.warn('[useLogCounts] Failed to fetch needs attention count', err);
      }
    );

    return () => {
      unsubscribeUnresolved();
      unsubscribeNeedsAttention();
    };
  }, []);

  return counts;
};

export default useLogCounts;
